/* src/app/shared/components/ngx-responsive-table/density.scss */
.ngx-responsive-table.tight ::ng-deep table thead tr th {
  height: 2.5333333333em;
  padding: 0.2666666667em 0.6666666667em 0.2666666667em 0.6666666667em;
}
.ngx-responsive-table.tight ::ng-deep table tbody tr ngx-toggle-switch {
  top: 0.5em;
}
.ngx-responsive-table.tight ::ng-deep table tbody tr td {
  height: 2.9230769231em;
  padding: 0.3076923077em 0.7692307692em 0.3076923077em 0.7692307692em;
}
/*# sourceMappingURL=density.css.map */
